<style scoped lang="scss"></style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mixture/order/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <template #top> </template>
      <template #conditions>
        <el-form size="mini" :inline="true" class="demo-form-inline">
          <el-form-item :label="$t('yixuangongdan')" class="noborder">
            {{ planId }}
          </el-form-item>
          <el-form-item :label="$t('kehedanwuliaobianma/mingcheng')">
            <yi_cross_select :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialId" @getItems="getItems"></yi_cross_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, beforeGet, afterReq)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear()">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 操作插槽 -->
      <template #yongliaoqingdan="scope">
        <el-row>
          <el-col :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '查看用料清单' } }">
            <el-button type="text" @click="yt.showEditDialog('yongliaoqingdan', scope.row, '80%')">
              {{ $t('chakan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button
              type="text"
              v-if="utils.checkPower('web_base_shift_item_update')"
              @click="
                yt.showEditDialog('bianji', scope.row);
                calculationTimeLength(scope.row);
              "
              >{{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_base_shift_item_delete')" class="font-color-danger" @click="yt.remove(scope.row, '/web/setting/shift/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 用料清单 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'yongliaoqingdan'">
        <div class="dialog-scroller">
          <materialList :materialObj="yt.editObj"></materialList>
        </div>
      </template>
    </el-dialog>
    <el-dialog :show-close="true" :title="$t('hebingqueren')" :visible.sync="combineShow" :close-on-click-modal="false" width="500px" append-to-body>
      <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
        <el-form-item class="noborder" :label="$t('hebinghoujihuahunliaozhongliang')" style="white-space: nowrap">
          <el-input v-model="total" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('chongxinzhipaizhixingren')" style="white-space: nowrap">
          <yi_data_select :multiple="false" :type="'customer_user'" :ids.sync="inputValue"></yi_data_select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="combineShow = false">{{ $t('quxiao') }}</el-button>
        <el-button size="mini" :loading="yt.editObj.loading" @click="saveCombine" type="primary">
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import materialList from '@@/pages/web/material_management/mixture_order/merge_orders/material_list';

export default {
  name: 'web_merge_orders_index',
  components: {
    materialList
  },
  data() {
    return {
      combineShow: false,
      inputValue: '',
      orgIds: [],
      mixingWeight: '', //本次混料重量
      originArray: [],
      materialIdlist: [],
      materialIds: null,
      planIdList: [],
      planId: null,
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'hunliaogongdanhao',
          prop: 'no',
          width: 130
        },
        {
          label: 'zhusudanhao',
          prop: 'wo.no'
        },
        {
          label: 'guishuchejian',
          prop: 'org.name'
        },
        {
          label: 'gongdanzhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'MIXTURE_ORDER_STATUS'
        },
        {
          label: 'jihuashuliang',
          prop: 'mixtureWeight'
        },
        {
          label: 'yongliaoqingdan',
          type: 'slot'
        }
      ]
    };
  },
  computed: {
    total() {
      return this.originArray.reduce((acc, current) => {
        return acc + current.mixtureWeight;
      }, 0);
    }
  },
  mounted() {},
  created() {
    setTimeout(() => {
      // table列表接口请求参数
      this.yt.conditions = {
        mergeFlag: 0,
        status: '0'
      };
      this.yt.get(1);
      this.utils.event_hub.$on('COMBINE_REFRESH', () => {
        // this.checkOrgId();
        this.checkArray();
      });
    }, 300);
  },
  methods: {
    // 重置
    clear() {
      let param = {
        mergeFlag: 0
      };
      this.yt.clear(param);
      this.originArray = [];
      this.planIdList = [];
      this.orgIds = [];
      this.planId = null;
    },
    //判断执行人存在与否
    checkDuplicates() {
      const seen = new Set();
      const duplicates = [];
      this.originArray.map(item => {
        if (seen.has(item.pic)) {
          duplicates.push(item.pic);
        } else {
          seen.add(item.pic);
        }
      });
      if (duplicates.length > 0) {
        this.inputValue = parseInt(duplicates[0]);
        // console.log('重复的pic值11:', duplicates);
      } else {
        this.inputValue = '';
      }
    },
    //判断所属组织是否存在
    checkArray() {
      if (this.originArray.length === 0) {
        console.log('数组为空');
        return;
      }
      const firstOrgId = this.originArray[0].orgId;
      let isAllSame = true;
      for (let i = 1; i < this.originArray.length; i++) {
        if (this.originArray[i].orgId !== firstOrgId) {
          isAllSame = false;
          break;
        }
      }
      if (isAllSame) {
        this.combineShow = true;
        console.log('数组中的orgId全部一致');
      } else {
        this.utils.errorMessage(this.$t('zuzhibuyizhibuyunxuhebing'));
        console.log('数组中的orgId全部buss一致');
      }
    },
    selectionChange(items) {
      this.originArray = items;
      this.planIdList = items.map(item => {
        return item.id;
      });
      this.orgIds = items.map(item => {
        return item.orgId;
      });
      this.checkDuplicates();
      this.planId = items
        .map(item => {
          return item.no;
        })
        .join(',');
    },
    getItems(items) {
      this.materialIdlist = items;
      for (let i = 0; i < this.materialIdlist.length; i++) {
        this.materialId = this.materialIdlist[i]['id'];
      }
    },
    afterReq(result) {
      this.originArray = [];
      this.planIdList = [];
      this.orgIds = [];
      this.planId = null;
      return result;
    },
    beforeGet(params) {
      params.mergeFlag = 0;
      return params;
    },
    //保存合并
    saveCombine() {
      this.yt.editObj.loading = true;
      let params = {
        orderIds: this.planIdList,
        picId: this.inputValue
      };
      if (Array.isArray(params['orderIds']) && params['orderIds'].length > 0) {
        params['orderIds'] = params['orderIds'].join(',');
      } else {
        params['orderIds'] = '';
      }
      return this.http
        .post('/web/mixture/order/merge?' + this.qs.stringify(params))
        .then(res => {
          this.combineShow = false;
          this.utils.event_hub.$emit('COMBINE_REFRESH_SAVE');
          this.utils.successMessage(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(error);
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    }
  }
};
</script>
